import React from "react"
import styled from "@emotion/styled"
import { connect } from "react-redux"

class SectionInput extends React.PureComponent {
  constructor(props) {
    super(props)
    this.inputRef = React.createRef()
    this.state = {
      pinToTop: false,
    }
  }
  handleChange = event => {
    this.props.setTextArea(event.target.value)
  }
  handleFocus = () => {
    this.props.setStopLoadingText(true)
  }
  type(i, force) {
    if (force || !this.props.stopLoadingText) {
      let text = this.props.hello_text_string
      let fragment = text.substr(0, i)
      this.props.setLoadingText(fragment)
      if (fragment.length < text.length) {
        this.typing_timeout = window.requestAnimationFrame(secs => {
          let elapsed = secs - this.state.startTime
          let next_i = Math.floor(elapsed / 100)
          if (next_i === 0) {
            next_i = 1
          }
          if (next_i > i + 2) {
            next_i = i + 2
          }
          this.type(next_i)
        })
      }
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
    this.props.setStopLoadingText(false)
    requestAnimationFrame(secs => {
      this.setState({ startTime: secs })
      this.type(1, true)
    })
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
    this.typing_timeout && window.cancelAnimationFrame(this.typing_timeout)
  }
  handleScroll = () => {
    if (!this.props.pageContext.textStyleId) {
      const scrollTop = this.inputRef.current.getBoundingClientRect().top
      this.setState({ pinToTop: scrollTop - (this.props.screenWidth <= 600 ? 66 : 42) <= 0 })
    }
  }
  render() {
    return (
      <>
        {
          !this.props.pageContext.textStyleId && <PinWrapper ref={this.inputRef} className={`${this.state.pinToTop ? "pinToTop" : ""}`}></PinWrapper>
        }
        <Wrapper
          className={`section textarea ${
            this.state.pinToTop && !this.props.pageContext.textStyleId ? "pinToTop" : ""
          }`}
          key={`section_input_${this.props.pageContext.section_id}`}
        >
          <div className="section_inner">
            <div className="name">{this.props.data.yourText.string}</div>
            <textarea
              onFocus={this.handleFocus}
              onChange={this.handleChange}
              value={this.props.textarea || this.props.loadingText}
            ></textarea>
          </div>
        </Wrapper>
      </>
    )
  }
}

const PinWrapper = styled("div")`
float:left;
clear:left;
font-size: 20px;
box-sizing: border-box;
height:0;
width:100%;
padding:0;
&.pinToTop {
  padding: 10px;
  height: 6em;
}
`

const Wrapper = styled("div")`
  &.pinToTop {
    position: fixed;
    top: 42px;
    z-index:500;
    background-color: #54b2bf;
    .section_inner {
      height: 6em;
    }
    @media screen and (max-width: 600px) {
      top: 66px;
    }
  }
  .name {
    float: left;
    width: 29%;
    font-size: 20px;
    line-height: 1.2;
  }
  textarea {
    font: inherit;
    font-size: 20px;
    box-sizing: border-box;
    float: left;
    width: 71%;
    background: rgba(255, 255, 255, 0.5);
    border: transparent;
    line-height: 1.2;
    height: 4.8em;
  }
  textarea:focus {
    outline: 0;
    background: rgba(255, 255, 255, 0.9);
  }
`

export default connect(
  state => {
    return {
      screenWidth: state.screenWidth,
      textarea: state.textarea,
      loadingText: state.loadingText,
      stopLoadingText: state.stopLoadingText,
    }
  },
  dispatch => {
    return {
      setStopLoadingText: value =>
        dispatch({ type: `STOP_LOADING_TEXT`, value: value }),
      setTextArea: value => dispatch({ type: `SET_TEXTAREA`, value: value }),
      setLoadingText: value =>
        dispatch({ type: `SET_LOADINGTEXT`, value: value }),
    }
  }
)(SectionInput)
